// src/utils/device.js

/**
 * 判断是否为移动端设备
 * @returns {Boolean} true=移动端，false=PC端
 */
export const isMobile = () => {
  // 增强判断逻辑：覆盖更多移动端场景，排除平板误判（可选）
  const ua = navigator?.userAgent?.toLowerCase() || '';
  const isMobileDevice = /mobile|android|iphone|ipod|blackberry|iemobile|opera mini/.test(ua);
  const isTablet = /ipad|tablet|kindle/.test(ua); // 单独区分平板（如需）
  // 若不需要区分平板，直接 return isMobileDevice;
  return isMobileDevice && !isTablet; 
};

/**
 * 可选：获取设备类型（扩展）
 * @returns {String} 'mobile'/'tablet'/'pc'
 */
export const getDeviceType = () => {
  const ua = navigator?.userAgent?.toLowerCase() || '';
  if (/mobile|android|iphone|ipod|blackberry|iemobile|opera mini/.test(ua)) {
    return 'mobile';
  } else if (/ipad|tablet|kindle/.test(ua)) {
    return 'tablet';
  }
  return 'pc';
};